<template>
    <div class="home">
      <LandingPage />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import LandingPage from '@/components/Landing/LandingHomePage.vue'
  
  export default {
    name: 'HomeView',
    components: {
      LandingPage
    }
  }
  </script>
  